export default "__VITE_ASSET__DTX7AJTO__"